import { render, staticRenderFns } from "./UploadCalls.vue?vue&type=template&id=604c0a75&scoped=true&"
import script from "./UploadCalls.vue?vue&type=script&lang=js&"
export * from "./UploadCalls.vue?vue&type=script&lang=js&"
import style0 from "./UploadCalls.vue?vue&type=style&index=0&id=604c0a75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c0a75",
  null
  
)

export default component.exports